import React from 'react';

import * as helpers from './helpers';

const FolderIcon = ({
  color,
  width = 28,
  height = 24,
  ...props
}: {
  color: string,
  width: number,
  height: number,
}) => (
  <svg
    {...helpers.getSvgDimensionsProps({ width, height })}
    {...helpers.getViewBoxProperty({ width, height })}
    {...props}
  >
    <path
      d="M24.5 7.5V4H12.25L10.5 0.5H3.5L1.75 4H0V23.25H24.5L28 7.5H24.5ZM26.075 9.25L23.275 21.5L2.45 21.325L6.475 9.25H26.075ZM1.75 5.75H2.8L4.55 2.25H9.1L11.2 5.75H22.75V7.5H5.25L1.75 17.825V5.75Z"
      fill="white"
    />
  </svg>
);

export default FolderIcon;
